export default "__VITE_PUBLIC_ASSET__0f8d4e75__"